import { getEEList } from 'Common/ee/registry';

const WIDGET_LABELS = {
  remediation: 'Remediation',
  bySeverity: 'By Severity',
  workspaceRisk: 'Workspace Risk',
  generalLatestFindings: 'Latest Findings',
  activityFeedWidget: 'Activity Feed',
  foundVsClosed: 'Found vs Closed',
  findingsByAsset: 'Findings by Asset',
  credentialsSummary: 'Credentials',
  securityScanners: 'Security Scanners',
  commandHistoryWidget: 'Tools Activity',
  vulnerabilities: 'Vulnerabilities',
  topServices: 'Top Services',
  topHosts: 'Top Hosts',
  latestVulns: 'Latest Vulns',
  statusChart: 'Status Chart',
  feeds: 'Feeds',
  summary: 'Summary',
  activityFeed: 'Activity Feed (Legacy)',
  workspaceDetails: 'Workspace Details',
  commandHistory: 'Command History (Legacy)',
  card: 'Card'
};

export const ADDABLE_WIDGETS = [
  'remediation',
  'bySeverity',
  'workspaceRisk',
  'generalLatestFindings',
  'activityFeedWidget',
  'credentialsSummary',
  'commandHistoryWidget'
  // 'foundVsClosed',
  // 'findingsByAsset'
];

/**
 * Widgets the user can add to a dashboard: the Core ones plus any Pro-only widget
 * registered under `dashboard-addable-widgets` in ee/register.js.
 * @returns {string[]} addable widget ids
 */
export const getAddableWidgets = () => [...ADDABLE_WIDGETS, ...getEEList('dashboard-addable-widgets')];

export default WIDGET_LABELS;
